/**
 * Ô dán link + chip sàn hỗ trợ + nút tạo link.
 *
 * Chip có logo để user thấy NGAY dán link sàn nào cũng ăn hoa hồng — trước đây chỉ
 * ghi tên sàn trong placeholder nên không ai biết có TikTok Shop.
 */
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight, faSpinner, faXmark } from "@fortawesome/free-solid-svg-icons";
import { PLATFORM_INFO, SUPPORTED_PLATFORMS } from "./detect-platform";

function PlatformChips({ active }) {
    return (
        <div className="flex flex-wrap gap-2 mb-3">
            {SUPPORTED_PLATFORMS.map((key) => {
                const meta = PLATFORM_INFO[key];
                const isActive = active === key;
                return (
                    <span
                        key={key}
                        className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1.5 rounded-full border transition-all ${
                            isActive
                                ? `${meta.bgColor} ${meta.textColor} ${meta.borderColor}`
                                : `bg-surface-sunken text-content-3 border-line ${active ? "opacity-45" : ""}`
                        }`}
                    >
                        <img src={meta.logo} alt="" className="w-4 h-4 object-contain" />
                        {meta.name}
                    </span>
                );
            })}
        </div>
    );
}

function LinkConverterInput({ value, platform, loading, onChange, onSubmit, onPaste, onClear }) {
    const meta = platform ? PLATFORM_INFO[platform] : null;

    return (
        <>
            <label className="text-sm font-semibold text-content-2 mb-2 block">
                Dán link sản phẩm
            </label>
            <PlatformChips active={platform} />

            <div
                className={`flex items-center gap-2 border-2 rounded-xl bg-surface transition-colors ${
                    meta ? meta.borderColor : "border-line-strong focus-within:border-brand-coral"
                }`}
            >
                {meta && <img src={meta.logo} alt="" className="w-5 h-5 object-contain ml-3 shrink-0" />}
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange(e.target.value)}
                    onPaste={(e) => {
                        const text = e.clipboardData.getData("text");
                        if (text) {
                            e.preventDefault();
                            onChange(text);
                        }
                    }}
                    onKeyDown={(e) => e.key === "Enter" && onSubmit()}
                    placeholder="Dán link Shopee, Lazada, TikTok Shop…"
                    // 16px (text-base): dưới ngưỡng này Safari iOS tự phóng to khi focus
                    className={`flex-1 bg-transparent py-3 text-base focus:outline-none min-w-0 ${meta ? "" : "pl-4"}`}
                />
                {value && (
                    <button
                        type="button"
                        onClick={onClear}
                        aria-label="Xoá link"
                        className="text-content-3 hover:text-content px-1 shrink-0"
                    >
                        <FontAwesomeIcon icon={faXmark} />
                    </button>
                )}
                <button
                    type="button"
                    onClick={onPaste}
                    className="text-xs text-brand-red font-semibold bg-red-50 px-3 py-2 mr-1.5 rounded-lg hover:bg-red-100 active:scale-95 transition-all shrink-0"
                >
                    Dán
                </button>
            </div>

            <button
                onClick={() => onSubmit()}
                disabled={loading || !value.trim()}
                className={`w-full mt-4 py-3.5 rounded-xl font-bold text-white text-sm transition-all active:scale-[0.98] ${
                    loading || !value.trim()
                        ? "bg-surface-raised cursor-not-allowed"
                        : "bg-gradient-to-r from-brand-red to-brand-warm shadow-md hover:shadow-lg"
                }`}
            >
                <span className="flex items-center justify-center gap-2">
                    <FontAwesomeIcon icon={loading ? faSpinner : faArrowRight} spin={loading} />
                    {loading ? "Đang tạo link..." : "Tạo link hoàn tiền"}
                </span>
            </button>
        </>
    );
}

export default LinkConverterInput;
